export default __webpack_public_path__ + "static/media/breakfast-logo.f1e901e1.svg";